import {
	Component,
	ChangeDetectionStrategy,
	computed,
	inject,
} from "@angular/core";
import { UpdateService } from "../../service/app-update.service";

@Component({
	selector: "app-update-indicator-bar",
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		@if (visible()) {
			<div
				class="update-bar"
				[class.update-bar--done]="isDone()"
				role="status"
				aria-label="Application update in progress"
			></div>
		}
	`,
	styles: `
		:host {
			display: block;
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			z-index: 9999;
			pointer-events: none;
			height: 3px;
		}

		.update-bar {
			height: 3px;
			width: 100%;
			background: linear-gradient(
				90deg,
				transparent 0%,
				var(--color-info, #17a2b8) 50%,
				transparent 100%
			);
			background-size: 200% 100%;
			animation: shimmer 1.5s ease-in-out infinite;
		}

		.update-bar--done {
			background: var(--color-success, #179f75);
			animation: fill-fade 2.5s ease-out forwards;
		}

		@keyframes shimmer {
			0% {
				background-position: -200% 0;
			}
			100% {
				background-position: 200% 0;
			}
		}

		@keyframes fill-fade {
			0% {
				opacity: 1;
				transform: scaleX(0);
				transform-origin: left;
			}
			40% {
				opacity: 1;
				transform: scaleX(1);
			}
			100% {
				opacity: 0;
				transform: scaleX(1);
			}
		}
	`,
})
export class UpdateIndicatorBarComponent {
	private updateService = inject(UpdateService);

	protected visible = computed(
		() => this.updateService.silentUpdateState() !== "idle",
	);

	protected isDone = computed(
		() => this.updateService.silentUpdateState() === "done",
	);
}
